import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  UPDATE_NOADATES_FAILURE,
  UPDATE_NOADATES_REQUEST,
  UPDATE_NOADATES_SUCCESS
} from "../types";

const updateNOADates = fundingRequestId => (
  debtorId,
  factoringId,
  active,
  placed
) => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(createAction(UPDATE_NOADATES_REQUEST)());
    const response = await api.factoring.updateNOADates(
      debtorId,
      factoringId,
      active,
      placed
    );
    const data = normalize(response, schema.debtorRelation);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(UPDATE_NOADATES_SUCCESS)({
        [fundingRequestId]: data.result
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(UPDATE_NOADATES_FAILURE)(err));
    throw err;
  }
};

export default updateNOADates;
